<script>
    import { onMount } from 'svelte';
    import { api_host, ppm_host, user_store, pricings_store, subscription_info_store, subdomain_manager, STRIPE_PUBLIC_KEY, redirect_uri } from '../stores.js';
    import { init_data } from '../init.js';
    import { push, querystring } from 'svelte-spa-router';
    import { toast_message } from '../utils/toast_message.js';
    import { formatDate } from '../utils/format.js';
    import Modal from './elements/Modal.svelte';
    import Radio from './elements/Radio.svelte';
    import { getToken, doFetch } from '../utils/Fetching.js';
    import { loadStripe } from '@stripe/stripe-js';
    import { Container, CardNumber, CardExpiry, CardCvc } from  'svelte-stripe';
    import Swal from "sweetalert2";

    export let title;
    export let is_busy = false;

    let confirm_modal_show = false;
    let card_modal_show = false;
    let plan_freq;
    let plan_type;
    let options = [];
    let subscription_info = {};
    let pricing_info = {};
    let myself = {};
    let pay_amount = 0;
    let subdomain = '';

	let stripe = null;
	let cardElement, cardExpiryElement, cardCvcElement;
    let cardNumberError, cardExpiryError, cardCvcError;
    let isCardNumber, isCardExpiry, isCardCvc;
	let name;
    let email;
	let processing = false;

    onMount(async () => {
        stripe = await loadStripe(STRIPE_PUBLIC_KEY);
    });

    user_store.subscribe(async value => {
        const params = new URLSearchParams($querystring);
        myself = value;
        plan_type = myself['plan_type'];
        if (myself['is_authenticated']) {
            name = `${myself.first_name} ${myself.last_name}`;
            email = myself.email;
        }
        if (myself['is_subscribed'] !== undefined) {
            if (myself['is_subscribed']) {
                confirm_modal_show = false;
            } else {
                if (title !== 'New User Registration' && !myself['subscription']['is_active']) {
                    // confirm_modal_show = true;
                    // toast_message(true, 'Choose a plan to unlock feature', 2000);

                    plan_freq = 'year';
                    submit();
                }
            }
        }
        if (myself['is_trial'] && params.has('trial')) {
            confirm_modal_show = true;
        }
    });
    subscription_info_store.subscribe(value => {
        subscription_info = value;
    });
    pricings_store.subscribe(value => {
        pricing_info = value;
    });
    subdomain_manager.subscribe(value => {
        subdomain = value;
    });

    $: {
        if (cardElement && cardExpiryElement && cardCvcElement) {
            cardElement.on('change', function(event) {
                isCardNumber = event.complete;
                cardNumberError = event.error;
            });
            cardExpiryElement.on('change', function(event) {
                isCardExpiry = event.complete;
                cardExpiryError = event.error;
            });
            cardCvcElement.on('change', function(event) {
                isCardCvc = event.complete;
                cardCvcError = event.error;
            });
        }
        if (((myself['is_subscribed'] !== undefined && !myself['is_subscribed']) || myself['is_trial']) && subscription_info['basic']) {
            const year_renew_date = new Date((new Date()).getFullYear() + 1, (new Date()).getMonth(), (new Date()).getDate());
            const _year_price = subscription_info[myself['plan_type']][0];
            const year_price = new Intl.NumberFormat().format(_year_price * 12);
            const month_renew_date = new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, (new Date()).getDate());
            const _month_price = subscription_info[myself['plan_type']][1];
            const month_price = new Intl.NumberFormat().format(_month_price);
            options = [{
                value: 'year',
                label: `Billed once a year for $${year_price}`,
                text: `You will be charged <b>$${year_price}</b>. Your subscription will automatically renew on ${formatDate(year_renew_date)} for $${year_price}. Cancel any time at least a day before each renewal date. <b>Warning: Upgrading or downgrading your plan will result in the loss of existing data.</b>`,
                save: new Intl.NumberFormat().format(_month_price * 12 - _year_price * 12)
            }, {
                value: 'month',
                label: `Billed once a month for $${month_price}`,
                text: `You will be charged <b>$${month_price}</b>. Your subscription will automatically renew on ${formatDate(month_renew_date)} for $${month_price}. Cancel any time at least a day before each renewal date. <b>Warning: Upgrading or downgrading your plan will result in the loss of existing data.</b>`,
                save: 0
            }];
        }
    }

    async function submit() {
        if (processing) return;
        processing = true;

		const { auth_type, auth_token, domain_code } = getToken();
		const res = await doFetch(
			api_host + '/api/subscription/secret/sub',
			'POST',
			{
                // payment_method: result.paymentMethod.id,
                name: `${name} (${myself.id})`,
                email,
                plan_type: myself.plan_type,
                plan_freq: plan_freq
            },
			{ Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
		);
        const { status, client_secret } = res;

        if (status === 'requires_action') {
            stripe.confirmCardPayment(client_secret).then(function(result) {
                if (result.error) {
                    Swal.fire({
                        title: 'Failed',
                        text: result.error.message || 'Invalid Card',
                        buttonsStyling: true,
                        cancelButtonText: "Cancel",
                        showCancelButton: true,
                        showConfirmButton: false,
                        icon: "error"
                    });
                } else {
                    // Swal.fire({
                    //     title: 'Payment Successful',
                    //     text: '',
                    //     buttonsStyling: true,
                    //     cancelButtonText: "Cancel",
                    //     showCancelButton: true,
                    //     showConfirmButton: false,
                    //     icon: "success"
                    // });
                }
            });
        } else if (status === 'succeeded') {
            Swal.fire({
                title: 'Registration Successful',
                text: '',
                buttonsStyling: true,
                cancelButtonText: "Ok",
                showCancelButton: true,
                showConfirmButton: false,
                icon: "success"
            }).then(e => {
                toast_message(true, 'Get started by setting up your company info', 3000);
                confirm_modal_show = false;
                card_modal_show = false;
                init_data('myself');
                init_data('all');
                setTimeout(() => {
                    push('#/Settingscompany?reg=first');
                }, 2000);
            });
        } else {
            toast_message(false, 'Invalid Card', 3000);
        }
        processing = false;
    }

    async function try_free_trial() {
        if (processing) return;
        processing = true;

		const { auth_type, auth_token, domain_code } = getToken();
		const res = await doFetch(
			api_host + '/api/subscription/secret/free_trial',
			'POST',
			{
                name: `${name} (${myself.id})`,
                email,
                plan_type: myself.plan_type,
                plan_freq: plan_freq
            },
			{ Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
		);
        const { status } = res;

        if (status === true) {
            Swal.fire({
                title: 'Free Trial Setup Successful',
                text: '',
                buttonsStyling: true,
                cancelButtonText: "Ok",
                showCancelButton: true,
                showConfirmButton: false,
                icon: "success"
            }).then(e => {
                toast_message(true, 'Thanks for signing up House of Yards!', 3000);
                confirm_modal_show = false;
                init_data('myself');
                init_data('all');
                setTimeout(() => {
                    push('#/Settingscompany?reg=first');
                }, 2000);
            });
        } else {
            toast_message(false, 'Failed. Try again later.', 3000);
        }
        processing = false;
    }
</script>


<div class="titleholder">
    <div class="title">{title}</div>
    <div class="usertools">
        <div class="buttonholder">
            {#if myself['is_authenticated'] && (!myself['is_subscribed'] || myself['is_trial']) && false}
                <button class="choose_plan" on:click={() => {
                    const params = new URLSearchParams($querystring);
                    if (params.has('domain_name')) {
                        subdomain = params.get('domain_name');
                    }
                    push(`#/Choose_Plan?domain_name=${subdomain}`);
                }}>
                    <i class="far fa-credit-card"></i> Choose Plan
                </button>
            {/if}
            {#if myself.plan_type !== 'basic'}
                <button class="createjob" on:click={() => {push("#/Redirect_Job_Create");}} disabled={!myself['is_authenticated'] || !myself['is_subscribed']}>
                    <i class="far fa-calendar-plus"></i> New Job
                </button>
            {/if}
        </div>
    </div>
</div>
{#if is_busy}
<div class="progress-line"></div>    
{/if}

<Modal bind:modal_show={card_modal_show} modal_width={window.innerWidth < 400 ? window.innerWidth - 10 : 400}>
    {#if stripe}
	<Container {stripe}>
        <form on:submit|preventDefault={submit}>
            <h4 style='color: #454545;'>Billing information</h4>
            <input name="name" bind:value={name} placeholder="Your name" />
            <CardNumber bind:element={cardElement} classes={{base: 'input'}} />
            {#if cardNumberError}
            <span class='error'>{cardNumberError.message}</span>
            {/if}
            <div class="row">
                <CardExpiry bind:element={cardExpiryElement} classes={{base: 'input'}} />
                <CardCvc bind:element={cardCvcElement} classes={{base: 'input'}} />
            </div>
            {#if cardExpiryError}
            <span class='error expiry_cvc'>{cardExpiryError.message}</span>
            {/if}
            {#if cardCvcError}
            <span class='error expiry_cvc'>{cardCvcError.message}</span>
            {/if}
            <button class='pay_btn' disabled={processing || !isCardNumber || !isCardExpiry || !isCardCvc}>
            {#if processing}
                Processing...
            {:else}
                <!-- Pay{pay_amount ? ` $${pay_amount}` : ''} -->
                Register
            {/if}
            </button>
        </form>
	</Container>
    {/if}
</Modal>

<Modal bind:modal_show={confirm_modal_show} modal_width={window.innerWidth < 600 ? window.innerWidth - 10 : 600}>
    {#if options.length}
    <Radio {options} fontSize={16} legend='' bind:userSelected={plan_freq}/>
    <p><i>{@html (plan_freq === 'year' ? options[0].text : options[1].text)}</i></p>
    <div class='buttons'>
        <button class='confirm_btn' on:click={() => { confirm_modal_show = false; }}>
            CANCEL
        </button>
        {#if myself && !myself.is_trial}
        <button class='confirm_btn try_free_trial' on:click={() => { try_free_trial(); }} disabled={processing}>
            TRY IT FREE FOR 14 DAYS
        </button>
        {/if}
        <button class='confirm_btn confirm_subsription' on:click={async () => {
            card_modal_show = true;
            confirm_modal_show = false;
            pay_amount = subscription_info[plan_type][plan_freq === 'year' ? 0 : 1] * (plan_freq === 'year' ? 12 : 1);
            pay_amount = new Intl.NumberFormat().format(pay_amount);
        }}>
            CONFIRM SUBSCRIPTION
        </button>
    </div>
    <span class='agree_tos'>By continuing, you agree to our <a href='https://houseofyards.tawk.help/article/privacy' style='color: black;' target='_blank'><b>Privacy Policy</b></a> and <a href='https://houseofyards.tawk.help/article/terms-of-service' style='color: black;' target='_blank'><b>Terms of Service</b></a></span>
    {/if}
</Modal>

<style>
    .agree_tos {
        display: block;
        margin-top: 15px;
        text-align: right;
        font-size: 12px;
    }
    .choose_plan {
        background-color: #e93636;
        color: white;
    }
    .error {
        margin-bottom: 10px;
        color: red;
        font-size: 13px;
        margin-left: 10px;
    }
    .error.expiry_cvc {
        margin-bottom: 0px;
    }
	form {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin: 2rem 0;
	}
	.row {
        display: flex;
        flex-direction: row;
        gap: 2%;
	}
    form {
        margin-bottom: 0px;
        padding-left: 15px;
        padding-right: 15px;
    }
	form input {
        border: solid 1px lightgray;
        padding: 1rem;
        border-radius: 5px;
        background: white;
	}
	form :global(.input) {
        border: solid 1px lightgray;
        padding: 1rem;
        border-radius: 5px;
        background: white;
	}
	.row :global(.input) {
	    width: 49%;
	}
    .row {
        margin-left: 0px;
        margin-right: 0px;
    }
	button.pay_btn {
        padding: 1rem;
        border-radius: 5px;
        border: solid 1px #ccc;
        color: white;
        background: #7c4dff;
        font-size: 1.2rem;
        margin: 1rem 0;
	}
    :global(.confirm_btn) {
        font-weight: 600;
        padding: 7px 12px;
        border-radius: 2px;
        font-size: 13px;
    }
    :global(.confirm_subsription) {
        color: white;
        background-color: #7db00e;
    }
    :global(.try_free_trial) {
        color: white;
        background-color: #222A1B;
    }
    .buttons {
        text-align: right;
    }
    .titleholder {
        width: 100%;
        border-bottom: 1px solid #ddd;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .title {
        font-size: 1.3rem;
        color: rgb(77, 102, 61);
        text-transform: capitalize;
    }
    .usertools {
        font-family: Poppins, "Font Awesome 5 Pro", "FontAwesome", "Font Awesome 5 Free" !important;	
        display: flex;
        align-items: center;
    }
    .progress-line, .progress-line:before {
        height: 5px;
        width: 100%;
        margin: 0;
        }
    .progress-line {
        background-color: #6fbf73;
        display: -webkit-flex;
        display: flex;
    }
    .progress-line:before {
        background-color: #357a38;
        content: '';
        -webkit-animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    }
    @-webkit-keyframes running-progress {
       0% { margin-left: 0px; margin-right: 100%; }
       50% { margin-left: 25%; margin-right: 0%; }
       100% { margin-left: 100%; margin-right: 0; }
    }
    @keyframes running-progress {
       0% { margin-left: 0px; margin-right: 100%; }
       50% { margin-left: 25%; margin-right: 0%; }
       100% { margin-left: 100%; margin-right: 0; }
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .titleholder {
            display: block;
            font-size: 1rem;
            width: 100%;
            border-bottom: 1px solid black;
        }
    }
</style>